import {useEffect, useState} from "react";
import {NoticeService} from "./services/NoticeService";
import {FormatDateTime} from "./helpers/FormatDateTime";
import truncate from "html-truncate";
import {GlobalRankingService} from "./services/GlobalRankingService";
import {NewLoading} from "./components/NewLoading";
import {useLocation, useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {AuthService} from "./services/AuthService";
import {useAuth} from "../contexts/AuthContext";


const NewLogin = () => {
    const { login } = useAuth();

    const navigate = useNavigate();

    const {getNotices} = NoticeService();
    const {getFightPowerRanking} = GlobalRankingService();

    const [notices, setNotices] = useState([]);
    const [noticesLoading, setNoticesLoading] = useState(false);

    const [fightPowerRanking, setFightPowerRanking] = useState([]);
    const [fightPowerRankingLoading, setFightPowerRankingLoading] = useState(false);

    const [loginLoading, setLoginLoading] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    useEffect(() => {
        noticesLoader();
        rankingLoader();
    }, []);

    const handleChange = (e) => {
        const {id, value, type, checked} = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: type === "checkbox" ? checked : value
        }));
    };

    const rankingLoader = async () => {
        const cachedRanking = localStorage.getItem("fightPowerRanking");
        if (cachedRanking) {
            setFightPowerRanking(JSON.parse(cachedRanking));
        } else {
            setFightPowerRankingLoading(true);
        }

        try {
            const response = await getFightPowerRanking(false, 5);
            setFightPowerRanking(response.data);
            localStorage.setItem("fightPowerRanking", JSON.stringify(response.data));
        } catch (err) {
            console.error("Erro ao buscar ranking:", err);
        }
        setFightPowerRankingLoading(false);
    };

    const noticesLoader = async () => {
        const cachedNotices = localStorage.getItem("notices");
        if (cachedNotices) {
            setNotices(JSON.parse(cachedNotices));
        } else {
            setNoticesLoading(true);
        }

        try {
            const response = await getNotices(1, 3);
            setNotices(response.data);
            localStorage.setItem("notices", JSON.stringify(response.data));
        } catch (err) {
            console.error("Erro ao buscar notices:", err);
        }
        setNoticesLoading(false);
    };

    const handleLogin = async () => {
        setLoginLoading(true);
        try {
            const response = await AuthService().login(formData.email, formData.password);
            login(response.data.data.user, response.data.data.token);
            setLoginLoading(false);
        } catch (e) {
            setLoginLoading(false);
            await Swal.fire({
                icon: "warning",
                title: "",
                text: e.response.data.message
            });
        }
    };

    return (<div className={"flex items-center justify-center p-4 login-page"}>
            <div className="login-container bg-white w-full max-w-6xl">
                <div className="flex flex-col md:flex-row">
                    {/*Logo and Login Form Section*/}
                    <div className="w-full md:w-1/2 p-8 flex flex-col">
                        <div className="flex items-cente">
                            <img alt={"logo"} src="/img/logo.png"></img>
                            {/*<div className="w-16 h-16 bg-blue-500 rounded-lg flex items-center justify-center mr-4">*/}
                            {/*    <i className="fas fa-gamepad text-white text-2xl"></i>*/}
                            {/*</div>*/}
                            {/*<h1 className="text-3xl font-bold text-gray-800">DDtank <span*/}
                            {/*    className="text-blue-500">Brasil</span></h1>*/}
                        </div>

                        <div className="flex-1 flex items-center">
                            <div className="w-full">
                                {
                                    !loginLoading ? (
                                        <>
                                            <h2 className="text-2xl font-semibold text-gray-800 mb-6">Faça login na sua
                                                conta</h2>
                                            <form className="space-y-4">
                                                <div>
                                                    <label htmlFor="email"
                                                           className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                                    <div className="relative">
                                                        <div
                                                            className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                            <i className="fas fa-user text-gray-400"></i>
                                                        </div>
                                                        <input type="text" id="email" name={"email"}
                                                               value={formData.email}
                                                               onChange={handleChange}
                                                               className="input-field pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                                               placeholder="Digite seu e-mail"/>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label htmlFor="password"
                                                           className="block text-sm font-medium text-gray-700 mb-1">Senha</label>
                                                    <div className="relative">
                                                        <div
                                                            className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                            <i className="fas fa-lock text-gray-400"></i>
                                                        </div>
                                                        <input type="password" id="password" name={"password"}
                                                               className="input-field pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                                               placeholder="Digite sua senha" onChange={handleChange}/>
                                                    </div>
                                                </div>

                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center">
                                                        <input id="remember-me" type="checkbox"
                                                               className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"/>
                                                        <label htmlFor="remember-me"
                                                               className="ml-2 block text-sm text-gray-700">Lembrar-me</label>
                                                    </div>

                                                    <a href="#" onClick={() => navigate('/forgotPassword')}
                                                       className="text-sm text-blue-500 hover:text-blue-700 hover:underline">Recuperar
                                                        senha</a>
                                                </div>

                                                <button type="button" onClick={handleLogin}
                                                        className="btn-login w-full py-3 px-4 text-white font-medium rounded-lg">
                                                    Entrar
                                                </button>

                                                <div className="text-center text-sm text-gray-500">
                                                    Não tem uma conta? <button type={"button"}
                                                                               onClick={() => navigate('/sign-up')}
                                                                               className="text-blue-500 hover:text-blue-700 hover:underline">Registre-se</button>
                                                </div>
                                            </form>
                                        </>
                                    ) : (
                                        <div className={"flex items-center justify-center"}>
                                            <NewLoading size={256}></NewLoading>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    {/*News and Ranking Section*/}
                    <div className="w-full md:w-1/2 bg-gray-50 p-8 flex flex-col">
                        {/*News Panel*/}
                        <div className="mb-8">
                            <div className="flex items-center mb-4">
                                <i className="fas fa-newspaper text-blue-500 mr-2"></i>
                                <h3 className="text-xl font-semibold text-gray-800">Notícias e Eventos</h3>
                            </div>

                            <div className="space-y-4">
                                {!noticesLoading ? (notices.map((item) => (
                                    <div className="news-item bg-white p-4 rounded-lg shadow-sm cursor-pointer"
                                         onClick={() => navigate(`/showNotice/${item.id}`)}>
                                        <div className="flex items-start">
                                            <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3">
                                                <i className="fa-solid fa-bullhorn"></i>
                                            </div>
                                            <div>
                                                <h4 className="font-medium text-gray-800">{item.title}</h4>
                                                <p
                                                    className="text-sm text-gray-600 mt-1"
                                                    dangerouslySetInnerHTML={{__html: truncate(item.content, 140)}}
                                                />

                                                <span
                                                    className="text-xs text-gray-400 mt-1 block">{FormatDateTime(item.created_at)}</span>
                                            </div>
                                        </div>
                                    </div>))) : (<NewLoading></NewLoading>)}
                            </div>
                        </div>

                        {/*Ranking Panel*/}
                        <div className="flex-1">
                            <div className="flex items-center mb-4">
                                <i className="fas fa-trophy text-blue-500 mr-2"></i>
                                <h3 className="text-xl font-semibold text-gray-800">Ranking Global</h3>
                            </div>

                            {!fightPowerRankingLoading ? (
                                <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                    <div className="grid grid-cols-3 bg-gray-100 text-gray-700 font-medium text-sm">
                                        <div className="py-2 px-4">Jogador</div>
                                        <div className="py-2 px-4">Poder</div>
                                        <div className="py-2 px-4">Servidor</div>
                                    </div>

                                    <div className="divide-y divide-gray-200">
                                        {fightPowerRanking.map((item) => (<div
                                            className="rank-item grid grid-cols-3 items-center hover:bg-gray-50">
                                            <div className="py-3 px-4 flex items-center">
                                                <div
                                                    className="rank-number w-6 h-6 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs font-bold mr-2">{item.rank}
                                                </div>
                                                <span
                                                    className="text-sm font-medium">{item.character_name}</span>
                                            </div>
                                            <div
                                                className="py-3 px-4 text-sm font-medium text-gray-800">{item.fight_power}
                                            </div>
                                            <div
                                                    className="py-3 px-4 text-sm text-gray-600">{item.server.name}</div>
                                            </div>))}
                                    </div>

                                    <div className="bg-gray-50 px-4 py-3 text-right">
                                        <button onClick={() => navigate('/globalranking')}
                                           className="text-sm text-blue-500 hover:text-blue-700 hover:underline">Ver
                                            ranking completo</button>
                                    </div>
                                </div>) : (<NewLoading></NewLoading>)}
                        </div>
                    </div>
                </div>

                {/*Footer*/}
                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush © 2025 - Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>);
};

export default NewLogin;